/* plantas finas — Wagen-Emoji in die Kaufbuttons der Produktkarten setzen

   Warum per JavaScript und nicht über CSS ::before:
   Dawn benutzt ::before und ::after seiner Buttons selbst für Rahmen und
   Schatten. Ein Zeichen darin erbt deren Positionierung und Farbe — das hat
   dreimal zu einem außermittigen oder unsichtbaren Symbol geführt.
   Ein echtes <span> im Button hat keine dieser Nebenwirkungen und wird von
   der Flexbox des Buttons sauber zentriert.

   Warum nicht direkt in Dawns card-product.liquid:
   Das ist eine Dawn-Datei. Beim nächsten Theme-Update wäre die Änderung weg. */
(function () {
  var ZEICHEN = '🛒'; /* Wagen-Emoji */

  function setzen(wurzel) {
    var buttons = (wurzel || document).querySelectorAll('.product-card-wrapper .quick-add__submit');

    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.querySelector('.pf-cart-emoji')) return;

      var span = document.createElement('span');
      span.className = 'pf-cart-emoji';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = ZEICHEN;

      btn.insertBefore(span, btn.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setzen(); });
  } else {
    setzen();
  }

  /* Dawn zeichnet die Karten bei Filtern, Sortieren und Blättern neu —
     dann müssen die neuen Buttons ihr Zeichen ebenfalls bekommen. */
  var beobachter = new MutationObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      if (eintraege[i].addedNodes.length) { setzen(); return; }
    }
  });

  beobachter.observe(document.body, { childList: true, subtree: true });
})();
